<template lang="pug">
.code.c_code(style="max-height: unset") {{ stats }}
</template>

<script>
export default {
  props: ['stats']
}
</script>
